module.exports = __webpack_public_path__ + "media/images/top/qa/img_step_2-0fe0d8641fe927f35715983c825debd0.png";